jQuery( document ).ready( function ( $ ) {
    let $languageDropdown = $( '#language-switcher' );
    let $menu = $( '#languages' );

    $(document).on('click', function (event) {
        if($languageDropdown === event.target || $languageDropdown.has(event.target).length > 0) {
            if ($menu.hasClass( "dropdown-content-opened" )) {
                $menu.removeClass( "dropdown-content-opened" );
            } else {
                $menu.addClass( "dropdown-content-opened" );
            }
        } else {
            $menu.removeClass( "dropdown-content-opened" );
        }
    } );
} );
